export default "/images/menu_dot.svg?63d27ce9c7f4f2d29a1bfcdd2782878e";